<template>
  <div class="flex gap-3 items-center">
    <LeagueLogo class="w-14 md:w-16 aspect-square rounded-md overflow-hidden" :name="league.name" :slug="league.slug" />
    <div class="-mt-0.5">
      <div class="font-heading font-bold text-2xl">{{ league.name }}</div>
      <h1 class="text-sm text-slate-500" v-html="heading || league.season?.year" />
    </div>
  </div>
</template>

<script setup>
const { t } = useI18n()
const route = useRoute()
const league = useLeagueStore()

const headingKeyMap = {
  'leagues-league-fixtures': 'pages.leagueFixtures.heading',
  'leagues-league-results': 'pages.leagueResults.heading',
  'leagues-league-table': 'pages.leagueTable.heading',
  'leagues-league-statistics': 'pages.leagueStatistics.heading',
}

const heading = computed(() => {
  const key = headingKeyMap[route.name]
  return key ? t(key, { league: league.name }) : ''
})
</script>
